import { clamp } from "lodash";

export const interpolateColor = (
    color1: string,
    color2: string,
    ratio: number
): string => {
    const ratioClamped = clamp(ratio, 0, 1);
    const hexToRgb = (hex: string) => {
        const bigint = parseInt(hex.slice(1), 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255
        };
    };

    const rgbToHex = (r: number, g: number, b: number) => {
        const toHex = (c: number) => c.toString(16).padStart(2, "0");
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    const color1Rgb = hexToRgb(color1);
    const color2Rgb = hexToRgb(color2);

    const r = Math.round(
        color1Rgb.r + ratioClamped * (color2Rgb.r - color1Rgb.r)
    );
    const g = Math.round(
        color1Rgb.g + ratioClamped * (color2Rgb.g - color1Rgb.g)
    );
    const b = Math.round(
        color1Rgb.b + ratioClamped * (color2Rgb.b - color1Rgb.b)
    );

    return rgbToHex(r, g, b);
};
